<template>
    <div class="contain">
        <div class="contents">
             <div class="youtube-wrapper">
                <iframe width="1200" height="675" src="https://www.youtube.com/embed/Sbq_s6Ts_l0?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <img class="imgs" src="../../../assets/c10/soldocpartners_medigate_01.png" />
            <img class="imgs" src="../../../assets/c10/soldocpartners_medigate_02.png" />
            <img class="c10_top_btn" @click="goEvent" src="../../../assets/c10/btn_medigate_01.png" />
            <img class="c10_bottom_btn" @click="goEvent" src="../../../assets/c10/btn_medigate_02.png" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'c10',
    methods: {
        goEvent: function()
        {
            window.open('https://partner.soldoc.co.kr/home?type=medigate', '_blank')
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 1200px;
        /* display: flex;
        justify-content: center;
        align-content: center; */
        /* position: relative; */
        /* background: black; */
    }
    .youtube-wrapper{
        width: 100%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 2080px;
    }
    .top{
        max-height: 700px;
        min-height: 700px;
        width: 100%;
        /* min-width: 1200px; */
        background: url('../../../assets/c9/pc/top.png');
        background-size: cover;
        position: relative;
    }
    .top_cover{
        position: absolute;
        max-height: 700px;
        min-height: 700px;
        width: 100%;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .navBar{
        width: 100%;
        min-height: 80px;
        max-height: 80px;
        background: #FFFFFF;
        border-bottom: 1px solid #CCCCCC;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background: blue; */
    }
    .barElement{
        width: 1200px;
        min-width: 1200px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        color: #1A1A1A;
    }
    .button{
        width: 174px;
        height: 48px;
        background: #018DDC;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Apple SD Gothic Neo';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        cursor: pointer;
    }
    .cover_text{
        color: #ffffff;
        font-family : 'Noto Sans KR';
        font-size: 64px;
        font-weight: 500;
    }
    .cover_sub_text{
        color: #ffffff;
        font-family : 'Noto Sans KR';
        font-size: 22px;
        font-weight: 400;
        margin-top: 20px;
    }
    
    .c1_fbtn{
        position: fixed;
        bottom: 20px;
        right: 10px;
        width: 80px;
        z-index: 10;
        cursor: pointer;
    }
    .c8_ibtn1{
        cursor: pointer;
    }
    .c8_ibtn2{
        cursor: pointer;
    }
    .c8_ibtn3{
        cursor: pointer;
    }
    .contents {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        width: 2000px;
    }
    .c9_btn1{
        position: absolute;
        top: 31px;
        right: 25%;
        transform: translate(75%, 0);
        cursor: pointer;
    }
    .imgs {
        width: 100%;
    }
    .c10_top_btn {
        position: absolute;
        top: 1520px;
        left: 50%;
        transform: translate(-50%, 0);
        cursor: pointer;
    }
    .c10_bottom_btn {
        position: absolute;
        bottom: 3830px;
        left: 50%;
        transform: translate(-50%, 0);
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/c10.vue